import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, SET_AXIOS_TOKEN } from '../actions/auth'
import axios from 'axios'

const state = {
    token: '',
    username: '',
    status: '',
    hasLoadedOnce: false
}

const getters = {
    isAuthenticated: state => !!state.token,
}

const actions = {
    [AUTH_REQUEST]: ({ commit, dispatch }, { username, password }) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST)
            axios({ url: '/api/auth/token', data: { username, password }, method: 'POST' })
                .then(resp => {
                    const { token, username } = resp.data
                    commit(AUTH_SUCCESS, { token, username })
                    dispatch(SET_AXIOS_TOKEN)
                    resolve(resp)
                })
                .catch(err => {
                    commit(AUTH_ERROR, err)
                    dispatch(SET_AXIOS_TOKEN)
                    reject(err)
                })
        })
    },
    [AUTH_LOGOUT]: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_LOGOUT)
            dispatch(SET_AXIOS_TOKEN)
            resolve()
        })
    },
    [SET_AXIOS_TOKEN]: ({ commit, state }) => {
        if (state.token) {
            axios.defaults.headers.common['Authorization'] = 'Token ' + state.token
        } else {
            delete axios.defaults.headers.common['Authorization']
        }
    }
}

const mutations = {
    [AUTH_REQUEST]: (state) => {
        state.status = 'loading'
    },
    [AUTH_SUCCESS]: (state, { token, username }) => {
        state.status = 'success'
        state.hasLoadedOnce = true
        state.token = token
        state.username = username
    },
    [AUTH_ERROR]: (state) => {
        state.status = 'error'
        state.hasLoadedOnce = true
        state.token = ''
        state.username = ''
    },
    [AUTH_LOGOUT]: (state) => {
        state.status = 'anonymous'
        state.token = ''
        state.username = ''
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
}